<template>
    <b-row class="match-height">
        <b-col :cols="12" :lg="12">
            <b-card
                bg-variant="primary"
                text-variant="white"
                class="text-center py-50"
            >
                <h3 class="text-white">
                    {{ $_getDollar(data.cost) }}
                </h3>
                <small>
                    {{ data.start }} - {{ isFilter ? data.end : undefined }}
                </small>
            </b-card>
        </b-col>
        <b-col :cols="4" :lg="4">
            <StatisticCardVertical
                icon="UserIcon"
                :statistic="$_getNumberFormat(data.accountCount, 0)"
                :statistic-title="$t('v4.Accounts')"
                color="info"
            />
        </b-col>
        <b-col :cols="4" :lg="4">
            <StatisticCardVertical
                icon="ShoppingBagIcon"
                :statistic="$_getNumberFormat(data.productCount, 0)"
                :statistic-title="$t('v4.Products')"
                color="danger"
            />
        </b-col>
        <b-col :cols="4" :lg="4">
            <StatisticCardVertical
                icon="BoxIcon"
                :statistic="$_getNumberFormat(data.lineItemCount, 0)"
                :statistic-title="$t('v4.Line Items')"
                color="warning"
            />
        </b-col>
    </b-row>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
export default {
    components: {
        StatisticCardVertical
    },
    props: {
        theme: {
            type: String
        },
        data: {
            type: Object,
            default: function () {
                return {}
            }
        },
        isFilter: {
            type: Boolean,
            default: false
        }
    },
    setup (props, context) {
        const { theme } = toRefs(props)
        const reverseTheme = computed(() => theme === 'light' ? 'dark' : 'light')
        return {
            reverseTheme
        }
    }
}
</script>

<style>

</style>
